import BRequest from "./BRequest";
import BSelect from "../front/Modules/BSelect";

export default class BDialogTrigger
{
	constructor(el)
	{
		this.el = el;
	}

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			const selector = `[data-dialog-selector]`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				event.preventDefault();

				void new this(event.target.closest(`${selector}`)).openModal();
			}
		});

		document.addEventListener("click", event => {
			if (event.target.matches(`.dialog .close-button, .dialog .close-button *, .dialog__close-button, .dialog__close-button *`)) {
				event.target.closest(`dialog`).close();
			}
		});

		document.addEventListener("click", event => {
			const dialog = event.target.closest("dialog");
			if (dialog && event.target === dialog) {
				dialog.close();
			}
		});
	}

	async openModal()
	{
		const dialog = document.querySelector(this.el.dataset.dialogSelector);
		if (!dialog) return;

		const scrollX = window.scrollX;
		const scrollY = window.scrollY;

		const asyncSrc = dialog.dataset.asyncDialogSrc;
		const bodyEl = dialog.querySelector("[data-async-dialog-body]");
		if (asyncSrc && dialog.dataset.asyncDialogLoaded !== "1") {
			if (dialog.dataset.asyncDialogLoaded === "loading") {
				dialog.showModal();
				window.scrollTo(scrollX, scrollY);

				return;
			}
			dialog.dataset.asyncDialogLoaded = "loading";
			dialog.showModal();
			window.scrollTo(scrollX, scrollY);
			try {
				const axiosResponse = await BRequest.get(asyncSrc, {}, {
					headers: {
						Accept: "application/json",
					},
				});
				const html = axiosResponse.data?.templates?.mealEditDialog;
				if (typeof html === "string" && bodyEl) {
					bodyEl.innerHTML = html;
					dialog.dataset.asyncDialogLoaded = "1";
				} else {
					throw new Error("mealEditDialog template missing");
				}
			} catch {
				dialog.dataset.asyncDialogLoaded = "";
				if (bodyEl) {
					bodyEl.innerHTML = "<p class=\"b-errors b-errors--block\">Nepodařilo se načíst formulář. Zkuste stránku obnovit.</p>";
				}
				requestAnimationFrame(() => {
					window.scrollTo(scrollX, scrollY);
				});

				return;
			}
			requestAnimationFrame(() => {
				window.scrollTo(scrollX, scrollY);
				dialog.querySelectorAll(BSelect.selector()).forEach(el => {
					BSelect.initializeElement(el);
				});
			});

			return;
		}

		// showModal() runs "dialog focusing steps" which can scroll the page
		// to the dialog's DOM position. Lock the scroll for the current frame.
		dialog.showModal();
		window.scrollTo(scrollX, scrollY);

		requestAnimationFrame(() => {
			window.scrollTo(scrollX, scrollY);
			dialog.querySelectorAll(BSelect.selector()).forEach(el => {
				BSelect.initializeElement(el);
			});
		});
	}
}
